module.exports = __webpack_public_path__ + "static/images/styles/images/nations/germany.c6ae38d4.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/germany.png
// module id = 3664
// module chunks = 11